
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { customizable } from '@cnamts/vue-dot/src/mixins/customizable';
	import { useNotificationStore } from '@/store/modules/notificationStore';
	import { config } from '@cnamts/vue-dot/src/patterns/NotificationBar/config';
	import { locales } from '@cnamts/vue-dot/src/patterns/NotificationBar/locales';
	import { mdiAlertCircleOutline, mdiAlertOctagonOutline, mdiCheckCircleOutline, mdiClose, mdiInformationOutline } from '@mdi/js';

	const Props = Vue.extend({
		props: {
			closeBtnText: {
				type: String,
				default: locales.close
			},
			bottom: {
				type: Boolean,
				default: false
			}
		}
	});

	const MixinsDeclaration = mixins(Props, customizable(config));

	@Component<CustomNotificationBar>({
		watch: {
			notification(): void {
				if (this.notification) {
					this.snackbarColor = this.options.snackBar.color as string || this.notification.type;
				}
			}
		}
	})
	export default class CustomNotificationBar extends MixinsDeclaration {
		closeIcon = mdiClose;
		notificationStore = useNotificationStore();

		get notification() {
			return this.notificationStore.notification;
		}

		clearNotification() {
			this.notificationStore.clearNotification();
		}

		handleSnackbarInput(val: boolean) {
			if (!val) {
				this.clearNotification();
			}
		}

		iconMapping = {
			info: mdiInformationOutline,
			success: mdiCheckCircleOutline,
			warning: mdiAlertCircleOutline,
			error: mdiAlertOctagonOutline
		};

		snackbarColor: string | null = null;

		get icon(): string | null {
			if (!this.notification) {
				return null;
			}

			return this.notification.icon || this.iconMapping[this.notification.type];
		}

		get isDarkText(): boolean {
			const { type } = this.notification || {};

			return !('success' === type || 'warning' === type || 'error' === type);
		}

		get contentColor(): string {
			return this.isDarkText ? 'grey-darken-80' : 'white';
		}

		get dividerColor(): string {
			return this.isDarkText ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.25)';
		}

		get hasLongContent(): boolean {
			return this.notification ? this.notification.message.length > 50 : false;
		}

		get smallCloseBtn(): boolean {
			return !this.hasLongContent;
		}

		get actionSlotAttrs(): Record<string, string | boolean> {
			return {
				color: this.contentColor,
				outlined: true,
				class: 'mr-4'
			};
		}

		created() {
			if (this.notification) {
				this.clearNotification();
			}
		}

		beforeDestroy() {
			this.clearNotification();
		}
	}
